<h3 mat-dialog-title>Versions</h3>
<mat-dialog-content>



    <mat-selection-list class="version-list stripe" [multiple]="false" [ngModel]="sVersionBind" (ngModelChange)="selectionChange($event)">
        <mat-list-option *ngFor="let v of this.versionsData; index as i" [value]="v.id" [style.background-color] = "i === 0 ? 'rgb(108, 194, 074)': ''">
          <mat-pseudo-checkbox [state]="v.id==this.sVersionSelected?'checked':'unchecked'"></mat-pseudo-checkbox>
          <span class="list-name">{{v["name"]}}</span>
        </mat-list-option>
      </mat-selection-list>

      <div class="versions-fields">
        <div>
        <label>Name</label>
          <input [readonly]="!this.showEditable || this.sVersionSelected=='0'" #nameField matInput type="text" class="aip-input" [(ngModel)]="this.sName" (keyup)="this.nameChange($event)"/>
        </div>
        <div>
        <label>Created By</label>
        <input readonly matInput type="text" class="aip-input readonly" [ngModel]="this.sCreatedBy"/>
      </div>
      <div>
      <label>Created On</label>
          <input readonly matInput type="text" class="aip-input readonly" [ngModel]="this.sCreatedOn"/>
      </div>

      <div *ngIf="showEditable" class="form-buttons">
        <button [disabled]="!this.showSave" mat-raised-button color="primary" class="aip-button" (click)="save()" cdkFocusInitial>Save</button>
        <button [disabled]="!this.showCancel" mat-raised-button class="aip-button-alt" (click)="cancel()">Cancel</button>
      </div>

      </div>

      <br>
      <div *ngIf="showEditable" class="action-buttons">
        <button [disabled]="!this.showAdd" mat-raised-button color="" class="aip-button" (click)="add()">Add</button>
        <button [disabled]="!this.showDelete" mat-raised-button color="warn" class="aip-button" (click)="delete()">Delete</button>
        </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button [style.background-color] = "disableSnapshot ? 'rgba(0,0,0,.12)': 'rgb(108, 194, 074)'" [disabled]="this.disableSnapshot" mat-raised-button class="aip-button-alt" (click)="quickAdd()">Snapshot</button>
    <button mat-raised-button color="primary" class="aip-button" (click)="select()" [mat-dialog-close]="data" cdkFocusInitial>Select</button>
    <button mat-raised-button class="aip-button-alt" (click)="close()">Cancel</button>
</mat-dialog-actions>
